// extracted by css-extract-rspack-plugin
export default {"list":"CHtbBU9_qsQSrWC4","item":"gAJnkL235KoO4VtB"};